import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPageList } from '../../slices/thunks';
import { createSelector } from 'reselect';
import UiContent from '../../Components/Common/UiContent';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import OSelect from '../../Components/OElements/OSelect';
import { getPageTypeList } from '../../helpers/screen/backend_helper';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

// Importar los componentes de las pantallas
import TitleImagePage from './BuildReport/Components/TitleImagePage';
import TitleGraphTextPage from './BuildReport/Components/TitleGraphTextPage';
import TitleTextGraphPage from './BuildReport/Components/TitleTextGraphPage';
import TitleTextPage from './BuildReport/Components/TitleTextPage';
import CoverPage from './BuildReport/Components/CoverPage';
import MenuImagePage from './BuildReport/Components/MenuImagePage';
import ImageSectionPage from './BuildReport/Components/ImageSectionPage';
import SectionImagePage from './BuildReport/Components/SectionImagePage';

const ReportBuilder = () => {
    const dispatch = useDispatch();

    const pageState = state => state.Screen;
    const pageProperties = createSelector(pageState, state => ({
        pages: state.pageList,
        isLoadingList: state.isLoadingList,
    }));

    const { pages, isLoadingList } = useSelector(pageProperties);

    const [selectedPages, setSelectedPages] = useState([]);
    const [selectedPageType, setSelectedPageType] = useState(null);

    const handlePageTypeSelect = (optionSelected) => {
        setSelectedPageType(optionSelected ? optionSelected.name : null);
        validation.setFieldValue('select_page_type', optionSelected ? optionSelected.name : null);
    };

    useEffect(() => {
        dispatch(getPageList());
    }, [dispatch]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            select_page_type: ''
        },
        validationSchema: Yup.object({
            select_page_type: Yup.string(),
        }),
        onSubmit: async (values) => {
            if (values.select_page_type) {
                setSelectedPages([...selectedPages, values.select_page_type]);
            }
        }
    });

    const breadcrumbLinks = [
        { to: '#', label: 'Inicio' },
        { to: '#', label: 'Empresa' },
        { to: '#', label: 'Configuración' }
    ];

    const renderSelectedPage = (pageType, index) => {
        switch (pageType) {
            case 'TitleImagePage':
                return <TitleImagePage key={index} />;
            case 'TitleGraphTextPage':
                return <TitleGraphTextPage key={index} />;
            case 'TitleTextGraphPage':
                return <TitleTextGraphPage key={index} />;
            case 'TitleTextPage':
                return <TitleTextPage key={index} />;
            case 'CoverPage':
                return <CoverPage key={index} />;
            case 'MenuImagePage':
                return <MenuImagePage key={index} />;
            case 'ImageSectionPage':
                return <ImageSectionPage key={index} />;
            case 'SectionImagePage':
                return <SectionImagePage key={index} />;
            default:
                return null;
        }
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title='Empresa' links={breadcrumbLinks} />

                    <Row>
                        <Col md={2}>
                            <OSelect
                                key={'select_page_type'}
                                label='Tipo de Slice'
                                id='select_page_type'
                                name='select_page_type'
                                handleLabelOptions={(item) => `${item.name}`}
                                requestApi={() => getPageTypeList({})}
                                onSelect={handlePageTypeSelect}
                                validation={validation}
                            />
                            <button onClick={validation.handleSubmit}>Agregar Pantalla</button>
                        </Col>
                        <Col md={10}>
                            {selectedPages.map((pageType, index) => (
                                <Card key={index}>
                                    <CardHeader>
                                        {pageType}
                                    </CardHeader>
                                    <CardBody>
                                        {renderSelectedPage(pageType, index)}
                                    </CardBody>
                                </Card>
                            ))}
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default ReportBuilder;
